import React from 'react'
import { VStack } from '@gluestack-ui/themed'

import FlowList from 'components/Flow/FlowList'

const PFW = (props) => {
  return (
    <VStack>
      <FlowList />
    </VStack>
  )
}

export default PFW
